module.exports = __webpack_public_path__ + "assets/img/1432.aaa889cb.svg";